export function normalize(str: string): string {
    return str
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '') // Remove all diacritics (accents)
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-|-$/g, '');
}